module.exports = __webpack_public_path__ + "img/face2.7e0e382d.jpg";